// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 928 ? "e18fe737" : chunkId) + "." + {"115":"beabfae6630e88f5","402":"021b89b695d3d076","490":"bc308909d2c7e169","537":"d12d96bc90932e6e","752":"6b4fcf1bc8793778","928":"315b0a1a7df7c9bb"}[chunkId] + ".js";
};